<!--
 * @Description: ''
 * @Author: yangruonan(yangruonan@hztianque.com)
 * @Date: 2021-04-28 09:51:39
 * @LastEditTime: 2021-05-06 11:14:40
-->
<template>
  <div class="filter">
    <div class="filter-box">
      <label>酒店名称：</label>
      <Input v-model="filter.hotelName" placeholder="请输入酒店名称" style="width:160px"></Input>
    </div>
    <div class="filter-box">
      <Button type="primary" @click="search">搜索</Button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      filter: {
        hotelName: '',
      },
    }
  },
  methods: {
    search() {
      this.$emit('query', this.filter)
    },
  },
}
</script>
<style lang="scss" scoped>
.filter {
  display: flex;
  .filter-box {
    margin-right: 20px;
  }
}
</style>